module.exports = __webpack_public_path__ + "img/IMG_1153-Edit.c739b456.jpg";